module.exports = __webpack_public_path__ + "img/member-center.aec2f918.png";